<div class="loader-container" *ngIf="loading">
  <div class="loader"></div>
</div>
<div *ngIf="!loading">
  <h1>{{ templateName }} Mail Template</h1>
  <div class="container">
    <div class="editor">
      <div class="save-button-container">
        <button class="primary-button save-button" type="button" (click)="onSave()" [disabled]="pristine">
          <i class="fa fa-floppy-o" aria-hidden="true"></i>
          Save
        </button>
      </div>
      <div>
        <editor [init]="editorSettings" [(ngModel)]="template">
        </editor>
      </div>
    </div>
    <div class="legend">
      <div class="legend-body">
        <h3>Field placeholders</h3>
        <table>
          <tbody>
            <tr>
              <td>
                <strong>${{'{PAYER_COUNTRY}'}}</strong>
                <span> - Payer Country</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{CURRENCY_CODE}'}}</strong>
                <span> - Currency Code</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{CPA_KEY}'}}</strong>
                <span> - CPA Key</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{DISCOUNT_PRODUCT_GROUP}'}}</strong>
                <span> - Discount Product Group</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{MEASUREMENT_PERIOD}'}}</strong>
                <span> - Measurement Period</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{DISCOUNT_PERIOD}'}}</strong>
                <span> - Discount Period</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{THRESHOLD_TYPE}'}}</strong>
                <span> - Threshold Type</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{DISCOUNT_TIERS_AND_VALUES}'}}</strong>
                <span> - Discount Tiers and Values</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{RAMP_UP_PERIOD}'}}</strong>
                <span> - Ramp up Period</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{RAMP_UP_START_DATE}'}}</strong>
                <span> - Ramp up Start Date</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{RAMP_UP_END_DATE}'}}</strong>
                <span> - Ramp up End Date</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{INITIAL_DISCOUNT_PERCENT}'}}</strong>
                <span> - Initial Discount Percent</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{INITIAL_DISCOUNT_PERIOD}'}}</strong>
                <span> - Initial Discount Period</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{CURRENT_DISCOUNT_PERCENT}'}}</strong>
                <span> - Current Discount Percent</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{PROGRESS_COUNT}'}}</strong>
                <span> - Progress Count</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{GAP_TO_CURRENT_LEVEL}'}}</strong>
                <span> - Gap to Current Level</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{GAP_TO_NEXT_LEVEL}'}}</strong>
                <span> - Gap to Next Level</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{NEXT_DISCOUNT_START_DATE}'}}</strong>
                <span> - Next Discount Start Date</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{NEXT_DISCOUNT_PERCENT}'}}</strong>
                <span> - Next Discount Percent</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{GAUGE_CHART}'}}</strong>
                <span> - Gauge Chart</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>${{'{THRESHOLD_CHART}'}}</strong>
                <span> - Threshold Chart</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>